export default {
  placeDetails: {
    layer: 'Stratul',
    lat: 'Lat.',
    lon: 'Lon.',
    notAvailable: 'Nu este disponibil',
    placeDetails: 'Detalii privind locul',
    placeName: 'Nume',
    latlngCopied: 'Latitudine și longitudine copiate',
    lnglatCopied: 'Longitudine și latitudine copiate',
    copyLatlng: 'Copiați în format latitudine, longitudine',
    copyLnglat: 'Copiați în format longitudine, latitudine',
    satelliteView: 'vedere din satelit',
  }
}
